/**
 * Default icon size in pixels
 */ const DEFAULT_ICON_SIZE = 20;

export { DEFAULT_ICON_SIZE };
//# sourceMappingURL=types.mjs.map
